module.exports = __webpack_public_path__ + "static/media/gw12.58bad86c.webp";